@if (showPlaceholder$()) {
  <div class="sol-image-placeholder" role="img" [attr.aria-label]="alt$()">
    <sol-icon [name]="placeholder$()!" size="auto" />
  </div>
} @else if (src$()) {
  <img
    [src]="src$()"
    [alt]="alt$()"
    [attr.role]="clickable$() ? 'button' : null"
    [attr.tabindex]="clickable$() ? 0 : null"
    (click)="onClick()"
    (keydown.enter)="onKeyActivate($event)"
    (keydown.space)="onKeyActivate($event)"
    (error)="onLoadError()"
  />
  @if (caption$(); as caption) {
    <div class="sol-image-caption sol-text-style-body-small sol-text-color-opacity-high">{{ caption | translate }}</div>
  }
}
